// Node modules
import { dispatcher, ingenuity } from "@quest/base-core/dist";
import { HoldAndReSpinView } from "../View/HoldAndReSpinView";
import { eventDispatchers } from "../../Constants/EventDispatchers";
import { BaseGameModel, SlotEventConstants } from "@quest/slot-core";
import { HoldAndRespinReelModel } from "../Model/HoldAndRespinReelModel";
import { HoldAndRespinReelPanel } from "../ReelPanel/HoldAndRespinReelPanel";
import { HoldAndReSpinCounterController } from "./HoldAndRespinCounterController";
import { HoldAndReSpinSpinningController } from "./HoldAndReSpinSpinningController";
import { EventConstants as platformEventConstants } from "@quest/platform-murka-phase_2/dist/EventConstants";

// Class modules
import { GameParserModel } from "../../Platform/GameParserModel";
import { YouWonFeatureView } from "../../YouWonFeature/YouWonFeatureView";
import { YouWonFeatureController } from "../../YouWonFeature/YouWonFeatureController";
import { JackpotWonFeatureView } from "../../JackpotWonFeature/JackpotWonFeatureView";
import { JackpotWonFeatureController } from "../../JackpotWonFeature/JackpotWonFeatureController";
import { SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { gameConstants } from "../../Constants/gameConstants";
import { HoldAndRespinUpdatePrizeContorller } from "./HoldAndRespinUpdatePrizeContorller";
import { HoldAndRespinWinCollectionView } from "../../HoldAndRespinWinCollection/HoldAndRespinWinCollectionView";
import { HoldAndRespinWinCollectionController } from "../../HoldAndRespinWinCollection/HoldAndRespinWinCollectionController";
import { SoundConstantGame } from "../../Constants/SoundConstantGame";
import { JackpotBannerBackgroundView } from "../../JackpotBannerBackground/JackpotBannerBackgroundView";
import { JackpotBannerBackgroundController } from "../../JackpotBannerBackground/JackpotBannerBackgroundController";
import { HoldAndRespinIntroView } from "../../HoldAndRespinIntro/HoldAndRespinIntroView";
import { HoldAndReSpinIntroController } from "../../HoldAndRespinIntro/HoldAndRespinIntroController";

export class HoldAndReSpinLogic {
  private view: HoldAndReSpinView;
  private holdAndRespinReelModel: HoldAndRespinReelModel;
  protected HoldAndRespinReelPanel: HoldAndRespinReelPanel;
  private jackpotWonFeatureView: JackpotWonFeatureView;
  private jackpotBannerBackgroundView: JackpotBannerBackgroundView;
  protected jackpotBannerBackgroundController: JackpotBannerBackgroundController;
  protected jackpotWonFeatureController: JackpotWonFeatureController;
  private youWonFeatureView: YouWonFeatureView;
  protected youWonFeatureController: YouWonFeatureController;
  protected holdAndReSpinIntroController: HoldAndReSpinIntroController;
  protected holdAndReSpinIntroView: HoldAndRespinIntroView;
  protected holdAndReSpinUpdatePrizeController: HoldAndRespinUpdatePrizeContorller;
  protected spinningController: HoldAndReSpinSpinningController;
  protected HoldAndReSpinCounterController: HoldAndReSpinCounterController;
  private holdAndReSpinWinCollectionView: HoldAndRespinWinCollectionView;
  protected holdAndReSpinWinCollectionController: HoldAndRespinWinCollectionController;
  private sequenceArray: string[] = [
    "holdAndReSpinIntroOutro",
    "showAdditionalSymbol",
    "updatePriceBigPrize",
    "updatePriceCollectAll",
    "updatePriceMultiplier",
    "Spinning",
    "jackpotWon",
    "winCollection",
    "youWon",
    "resetAndSendClose",
  ];
  private sequenceCounter: number = 0;
  private baseGameModel: BaseGameModel;

  constructor(view: HoldAndReSpinView, model: BaseGameModel) {
    this.view = view;
    this.baseGameModel = model;
    this.subscribeEvents();
    this.init();
  }

  private subscribeEvents(): void {
    this.unSubscribeEvents();
    // dispatcher.on(eventDispatchers.START_HOLD_AND_RESPIN_GAME, this.startHoldAndReSpinGame, this);
    dispatcher.on(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION, this.onShowNextFeaturePresentation, this);
  }
  private unSubscribeEvents(): void {
    // dispatcher.off(eventDispatchers.START_HOLD_AND_RESPIN_GAME, this.startHoldAndReSpinGame, this);
    dispatcher.off(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION, this.onShowNextFeaturePresentation, this);
  }
  private init(): void {
    this.initializeFeatureReelModel();
    this.initializeSpinningController();
    this.initializeCounterController();
    this.initializeJackpotBackground();
    this.initializeIntroController();
    this.initializeJackpotWonFeature();
    this.initializeYouWonFeature();
    this.initializeUpdatePriceController();
    this.initializeWinCollection();
  }
  /**
   * initialize feature controller
   */
  private initializeIntroController(): void {
    if (!this.holdAndReSpinIntroView) {
      this.holdAndReSpinIntroView = new HoldAndRespinIntroView( ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).holdAndRespinIntro)
      this.holdAndReSpinIntroController = new HoldAndReSpinIntroController(this.holdAndReSpinIntroView);
    }
  }

  /**
   * initialize update prize controller
   */
  private initializeUpdatePriceController(): void {
    if (!this.holdAndReSpinUpdatePrizeController) {
      this.holdAndReSpinUpdatePrizeController = new HoldAndRespinUpdatePrizeContorller(this.view);
    }
  }
  /**
   * initialize feature reelmodel
   */
  private initializeFeatureReelModel(): void {
    if (!this.holdAndRespinReelModel) {
      this.holdAndRespinReelModel = new HoldAndRespinReelModel();
      this.holdAndRespinReelModel.json = ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).Bonusreels;
    }
  }

  /**
   * This method will initialize the classes for orb/feature amt collection
   */
  private initializeWinCollection(): void {
    if (!this.holdAndReSpinWinCollectionView) {
      this.holdAndReSpinWinCollectionView = new HoldAndRespinWinCollectionView(
        ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).holdAndReSpinWinCollection
      );
      this.holdAndReSpinWinCollectionController = new HoldAndRespinWinCollectionController(this.holdAndReSpinWinCollectionView);
      ingenuity.currentGame.stage.addChild(this.holdAndReSpinWinCollectionView);
    }
  }

  /**
   * initialize spinning counter , responsible for spinning flow and symbol stops behavior
   */
  private initializeSpinningController(): void {
    if (!this.spinningController) {
      this.spinningController = new HoldAndReSpinSpinningController(this.view, this.holdAndRespinReelModel);
    }
  }
  private initializeCounterController(): void {
    if (!this.HoldAndReSpinCounterController) {
      this.HoldAndReSpinCounterController = new HoldAndReSpinCounterController(this.view, this.holdAndRespinReelModel);
    }
  }

  // to initialize view and controller of jackpot feature /
  private initializeJackpotBackground(): void {
    if (!this.jackpotBannerBackgroundView) {
      this.jackpotBannerBackgroundView = new JackpotBannerBackgroundView(
        ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).jackpotBannerBackground
      );
      this.jackpotBannerBackgroundController = new JackpotBannerBackgroundController(this.jackpotBannerBackgroundView);
      ingenuity.currentGame.stage.addChild(this.jackpotBannerBackgroundView);
    }
  }

  // to initialize view and controller of jackpot feature /
  private initializeJackpotWonFeature(): void {
    if (!this.jackpotWonFeatureView) {
      this.jackpotWonFeatureView = new JackpotWonFeatureView(
        ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).jackpotWonFeature
      );
      this.jackpotWonFeatureController = new JackpotWonFeatureController(this.jackpotWonFeatureView);
      ingenuity.currentGame.stage.addChild(this.jackpotWonFeatureView);
    }
  }
  // Class method to initialize You won presentation
  protected initializeYouWonFeature(): void {
    if (!this.youWonFeatureView) {
      this.youWonFeatureView = new YouWonFeatureView(ingenuity.assetsData.getJSONById(SlotConstantsBehavior.MAIN_DATA).youWonFeature);
      this.youWonFeatureController = new YouWonFeatureController(this.youWonFeatureView);
      ingenuity.currentGame.stage.addChild(this.youWonFeatureView);
    }
  }

  /**
   * Method to show next Feature presentation in sequence
   */
  private onShowNextFeaturePresentation(): void {
    const currentWinEventToShow = this.sequenceArray[this.sequenceCounter];
    this.updateSequenceCounter();
    switch (currentWinEventToShow) {
      case "holdAndReSpinIntroOutro":
        this.onShowBonusIntro();
        break;
      case "showAdditionalSymbol":
        this.onShowAddtionalSymbolOnReel();
        break;
      case "updatePriceMultiplier":
        this.onUpdatePriceMultiplier();
        break;
      case "updatePriceBigPrize":
        this.onUpdatePriceBigPrize();
        break;
      case "updatePriceCollectAll":
        this.onUpdatePriceCollectAll();
        break;
      case "Spinning":
        this.onShowReels();
        break;
      case "winCollection":
        this.onShowWinCollection();
        break;
      case "jackpotWon":
        this.onShowJackpotWon();
        break;
      case "youWon":
        this.onShowYouWon();
        break;
      case "resetAndSendClose":
        this.resetAndSendClose();
        break;
    }
  }
  /**
   * Method to updates presentation sequence counter
   */
  private updateSequenceCounter(): void {
    this.sequenceCounter += 1;
  }
  /**
   * Method to show Intro Outro presentation
   */
  private onShowBonusIntro(): void {
    if (this.baseGameModel.getIsAutoPlayLeft()) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_AUTOPLAY_BEFORE_FEATURE);
    }
    ((ingenuity.parserModel as GameParserModel).getPromotionalFreeGame()) && dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_HIDE_PROMOTIONAL_FREE_PLAY, false);
    dispatcher.fireEvent(eventDispatchers.SHOW_TRIGGERED_SKULLS);
    dispatcher.fireEvent(eventDispatchers.SHOW_HOLD_AND_RESPIN_INTRO);
  }

  /**
   * Method to show Reel Spinning  presentation
   */
  private onShowAddtionalSymbolOnReel(): void {
    (ingenuity.soundManager as any).stop(SoundConstantGame.BONUS_INTRO_SOUND, 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
    (ingenuity.soundManager as any).playSound(SoundConstantGame.BONUS_BGM, 1, true, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
    dispatcher.fireEvent(eventDispatchers.SHOW_INITIAL_COINS_ON_REEL);
  }

  /**
   * method to start update prize presentation for multiplier
   */
  private onUpdatePriceMultiplier(): void {
    let triggerType = (ingenuity.parserModel as GameParserModel).getHoldAndRespinType();
    if (triggerType.includes(gameConstants.SKULL_MULTIPLIER)) {
      dispatcher.fireEvent(eventDispatchers.UPDATE_SYMBOL_PRICE_MULTIPLER);
    } else {
      dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
    }
  }
  /**
   * method to start update prize presentation for multiplier
   */
  private onUpdatePriceBigPrize(): void {
    let triggerType = (ingenuity.parserModel as GameParserModel).getHoldAndRespinType();
    if (triggerType.includes(gameConstants.SKULL_BIG_PRIZE)) {
      dispatcher.fireEvent(eventDispatchers.UPDATE_SYMBOL_PRICE_BIG_PRIZE);
    } else {
      dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
    }
  }
  /**
   * method to start update prize presentation for multiplier
   */
  private onUpdatePriceCollectAll(): void {
    let triggerType = (ingenuity.parserModel as GameParserModel).getHoldAndRespinType();
    if (triggerType.includes(gameConstants.SKULL_COLLECT_ALL)) {
      dispatcher.fireEvent(eventDispatchers.UPDATE_SYMBOL_PRICE_COLLECT_ALL);
    } else {
      dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
    }
  }
  /**
   * Method to show Reel Spinning  presentation
   */
  private onShowReels(): void {
    dispatcher.fireEvent(eventDispatchers.INITIATE_REEL_SPINNING);
  }
  /**
   * Method to show win collection presentation
   */
  private onShowWinCollection(): void {
    (ingenuity.soundManager as any).stop(SoundConstantGame.BONUS_BGM, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
    dispatcher.fireEvent(eventDispatchers.START_WIN_COLLECTION);
  }
  /**
   * Method to show jackpot won presentation
   */
  private onShowJackpotWon(): void {
    if ((ingenuity.parserModel as GameParserModel).getJackpotAvailable()) {
      dispatcher.fireEvent(eventDispatchers.PLAY_ALL_SKULL_ANIM, 0);
    } else {
      this.onShowNextFeaturePresentation();
    }
  }
  /**
   * Method to show you won banner presentation presentation
   */
  private onShowYouWon(): void {
    dispatcher.fireEvent(eventDispatchers.SHOW_BONUS_OUTRO, "BONUS_OUTRO");
    dispatcher.fireEvent(eventDispatchers.SHOW_YOU_WON_OUTRO);
  }

  /**
   * This method resets the hold and re spin feature and its component classes and update winmeter.
   */
  private resetAndSendClose(): void {
    this.sequenceCounter = 0;
    dispatcher.fireEvent(eventDispatchers.RESET_COUNTERS);
    this.spinningController.resetFeature();
    dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    dispatcher.fireEvent(platformEventConstants.UPDATE_BS_WIN, {
      value:
       (ingenuity.parserModel as GameParserModel).getBaseGameWinAmt(),
    });
    this.resetControllers();
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
  }
  private resetControllers(): void {
    this.youWonFeatureView.destroy();
    this.jackpotBannerBackgroundView.destroy();
    this.jackpotWonFeatureView.destroy();
    this.holdAndReSpinWinCollectionView.destroy();
    this.holdAndReSpinWinCollectionController = null;
    this.HoldAndReSpinCounterController = null;
    this.holdAndReSpinWinCollectionView = null;
    this.holdAndReSpinIntroController = null;
    this.jackpotBannerBackgroundController = null;
    this.jackpotWonFeatureController = null;
    this.youWonFeatureController = null;
    this.holdAndRespinReelModel = null;
    this.jackpotWonFeatureView = null;
    this.spinningController = null;
    this.youWonFeatureView = null;
    dispatcher.fireEvent(eventDispatchers.DESTROY_HOLD_AND_RESPIN);
  }
}
